import React from 'react';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import { Tab } from './types';
import * as styles from './MobilePreview.css';

interface TabsSectionProps {
  tabs: Tab[];
  activeTabId: string | number;
  primaryColor: string;
}

export const TabsSection = ({
  tabs,
  activeTabId,
  primaryColor,
}: TabsSectionProps) => {
  return (
    <>
      <div className={styles.tabsContainer}>
        {tabs.map((tab) => (
          <span
            key={tab.id}
            className={`${styles.tab} ${
              activeTabId === tab.id
                ? styles.tabVariants.active
                : styles.tabVariants.inactive
            }`}
            style={
              activeTabId === tab.id
                ? assignInlineVars({
                    [styles.colorVar]: primaryColor,
                  })
                : undefined
            }
          >
            {tab.label || tab.name}
          </span>
        ))}
      </div>
      <hr className={styles.separator} />
    </>
  );
};
